import * as React from "react";

import "./add-address-panel.scss";

import {bindInput}     from "@Common/react/bind-input";
import {cs}            from "@Common/react/chain-services";
import {onChangeState} from "@Common/react/on-change-state";
import {scopedState}   from "@Common/react/scoped-state";
import {scnv}          from "@Common/react/state-change-nested-value";
import {UseState}      from "@Common/react/use-state";
import {Responsive}    from "@Common/ui-components/responsive";
import {Select2}       from "@Common/ui-components/select-2/select-2";

import {ModalLayout}   from "@Xpresso/routes/common/modal-layout/modal-layout";
import { Radio } from "@Common/ui-components/heavy/common/design2/radio/radio";

const US_STATES = require("@Common/ui-components/heavy/common/us-states.json");

export const AddAddressPanel = ({officeId, importContent, noti, next}) => cs(
     // @ts-ignore
     ["responsive", ({}, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["errorState", ({}, next) => UseState({next, initValue: ""})],
    ["address", ({errorState}, next) => UseState({
        initValue: {
            officeId,
            address: "",
            address2: "",
            city: "",
            state: undefined,
            zip: "",
        },
        next: (state) => next(onChangeState({state, onChange: () => errorState.onChange(null)})),
    })],
    ["radioSelected", ({}, next) => UseState({initValue: "manual", next})],
    ({address, radioSelected, errorState, responsive}) => next({
        render: ({onSave, onCancel}) => cs(
            ["saving", ({}, next) => UseState({next, initValue: false})],
            ({saving}) => ModalLayout({
                content: (
                    <div className="add-address-panel-62k">
                        <div className="title-container">
                            <div className="radio-button">
                                {Radio({
                                    selected: radioSelected.value === "manual",
                                    onClick: () => radioSelected.onChange("manual"),
                                    size: "large",
                                    xdQaName: "Manual"
                                })}
                            </div>
                            <div className="text-title">
                                <h2 className="title" xd-qa-type="label" xd-qa-name="Exclude Address">Exclude address</h2>
                                <div className="subtitle" xd-qa-type="label" xd-qa-name="Exclude Address Subtitle">Enter the address you wish to exclude</div>
                            </div>
                        </div>
                        <form className="content-lines">
                            <div className="line">
                                <div className="left required" xd-qa-type="label" xd-qa-name="Address 1">
                                    Address 1
                                </div>
                                <div className="right">
                                    <input {...{
                                            ...bindInput(scopedState(address, ["address"])),
                                        }}
                                        xd-qa-type="text_field"
                                        xd-qa-name="Address 1"
                                    />
                                </div>
                            </div>
                            <div className="line">
                                <div className="left" xd-qa-type="label" xd-qa-name="Address 2">
                                    Address 2
                                </div>
                                <div className="right">
                                    <input {...{
                                            ...bindInput(scopedState(address, ["address2"])),
                                        }}
                                        xd-qa-type="text_field"
                                        xd-qa-name="Address 2"
                                    />

                                </div>
                            </div>
                            <div className="line">                                
                                {
                                    responsive.lt("md")
                                    ?                                       
                                    <div className="left required" xd-qa-type="label" xd-qa-name="City" >
                                        City
                                    </div>
                                    :
                                    <div className="left required" xd-qa-type="label" xd-qa-name="City State Zip">
                                        City, &nbsp;&nbsp;State, &nbsp;&nbsp;Zip
                                    </div>
                                }                                
                                <div className="right triple-input">

                                    <input {...{
                                            placeholder: "City",
                                            ...bindInput(scopedState(address, ["city"])),
                                        }}
                                        xd-qa-type="text_field"
                                        xd-qa-name="City"
                                    />
                                    {
                                        responsive.lt("md")
                                        ?
                                        <div className="required" xd-qa-type="label" xd-qa-name="State" >
                                            State
                                        </div>
                                        :
                                        null
                                    }
                                    {Select2<any>({
                                        list: US_STATES,
                                        getLabel: (i) => i.abbreviation,
                                        isSelected: (i) => i.abbreviation === address.value.state,
                                        onSelect: (i) => {
                                            scnv(address, ["state"], () => i?.abbreviation);
                                        },
                                        disableClearingSelection: true,
                                        placeholder: 'State',
                                        xdQaName: "State"
                                    })}
                                    {
                                        responsive.lt("md")
                                        ?
                                        <div className="required" xd-qa-type="label" xd-qa-name="Zip" >
                                            Zip
                                        </div>
                                        :
                                        null
                                    }
                                    <input {...{
                                            className: "zip",
                                            placeholder: "Zip",
                                            ...bindInput(scopedState(address, ["zip"])),
                                        }}
                                        xd-qa-type="text_field"
                                        xd-qa-name="Zip"
                                    />

                                </div>
                            </div>
                        </form>

                        <div className="title-container">
                            <div className="radio-button">
                                {Radio({
                                    selected: radioSelected.value === "upload",
                                    onClick: () => radioSelected.onChange("upload"),
                                    size: "large",
                                    xdQaName: "Upload"
                                })}
                            </div>
                            <div className="text-title">
                                <h2 className="title" xd-qa-type="label" xd-qa-name="Exclude Address">Import Spreadsheet</h2>
                                <div className="subtitle" xd-qa-type="label" xd-qa-name="Exclude Address Subtitle">Upload a spreadsheet containing addresses to exclude</div>
                            </div>
                        </div>

                        {errorState.value && (
                            <div className="error-field" xd-qa-type="label" xd-qa-name="Error">
                                {errorState.value}
                            </div>
                        )}
                    </div>
                ),
                buttons: [
                    {
                        label: "Back",
                        onClick: onCancel,
                    },
                    {
                        label: saving.value ? "Saving..." : "Next",
                        primary: true,
                        disabled: radioSelected.value === "manual" && (validateAddressFields(address.value) || saving.value),
                        onClick: async () => {
                            if(radioSelected.value === "manual") {
                                saving.onChange(true);
                                try {
                                    await onSave(address.value);
                                } catch (e) {
                                    noti.show({
                                        message: e,
                                        color: "red",
                                        duration: 3000,
                                    });
                                } finally {
                                    saving.onChange(false);
                                }
                            }
                            else if(radioSelected.value === "upload"){
                                importContent.onChange("upload")
                            }
                        },
                    }
                ]
            }),
        ),
    }),
);

const validateAddressFields = address => (
    address?.address == "" ||
    address?.city == "" ||
    address?.state == undefined ||
    address?.zip == ""
);
